import { GameMap } from "../games";

export default [
  { 
        name: 'start',
        title: 'Introduction',
        collection: ''
    },
    { 
        name: 'e1m1',
        title: 'The Slipgate Complex',
        collection: 'Episode 1'
    },
    { 
        name: 'e1m2',
        title: 'Castle of the Damned',
        collection: 'Episode 1'
    },
    { 
        name: 'e1m3',
        title: 'The Necropolis',
        collection: 'Episode 1'
    },
    { 
        name: 'e1m4',
        title: 'The Gristly Grotto',
        collection: 'Episode 1'
    },
    { 
        name: 'e1m5',
        title: 'Gloom Keep',
        collection: 'Episode 1'
    },
    { 
        name: 'e1m6',
        title: 'The Door to Chthon',
        collection: 'Episode 1'
    },
    { 
        name: 'e1m7',
        title: 'The House of Chthon',
        collection: 'Episode 1'
    },
    { 
        name: 'e1m8',
        title: 'Ziggurat Vertigo',
        collection: 'Episode 1'
    },
    { 
        name: 'e2m1',
        title: 'The Installation',
        collection: 'Episode 2'
    },
    { 
        name: 'e2m2',
        title: 'The Ogre Citadel',
        collection: 'Episode 2'
    },
    { 
        name: 'e2m3',
        title: 'The Crypt of Decay',
        collection: 'Episode 2'
    },
    { 
        name: 'e2m4',
        title: 'The Ebon Fortress',
        collection: 'Episode 2'
    },
    { 
        name: 'e2m5',
        title: 'The Wizard\'s Manse',
        collection: 'Episode 2'
    },
    { 
        name: 'e2m6',
        title: 'The Dismal Oubliette',
        collection: 'Episode 2'
    },
    { 
        name: 'e2m7',
        title: 'The Underearth',
        collection: 'Episode 2'
    },
    { 
        name: 'e3m1',
        title: 'Termination Central',
        collection: 'Episode 3'
    },
    { 
        name: 'e3m2',
        title: 'The Vaults of Zin',
        collection: 'Episode 3'
    },
    { 
        name: 'e3m3',
        title: 'The Tomb of Terror',
        collection: 'Episode 3'
    },
    { 
        name: 'e3m4',
        title: 'Satan\'s Dark Delight',
        collection: 'Episode 3'
    },
    { 
        name: 'e3m5',
        title: 'The Wind Tunnels',
        collection: 'Episode 3'
    },
    { 
        name: 'e3m6',
        title: 'Chambers of Torment',
        collection: 'Episode 3'
    },
    { 
        name: 'e3m7',
        title: 'The Haunted Halls',
        collection: 'Episode 3'
    },
    { 
        name: 'e4m1',
        title: 'The Sewage System',
        collection: 'Episode 4'
    },
    { 
        name: 'e4m2',
        title: 'The Tower of Despair',
        collection: 'Episode 4'
    },
    { 
        name: 'e4m3',
        title: 'The Elder God Shrine',
        collection: 'Episode 4'
    },
    { 
        name: 'e4m4',
        title: 'The Palace of Hate',
        collection: 'Episode 4'
    },
    { 
        name: 'e4m5',
        title: 'Hell\'s Atrium',
        collection: 'Episode 4'
    },
    { 
        name: 'e4m6',
        title: 'The Pain Maze',
        collection: 'Episode 4'
    },
    { 
        name: 'e4m7',
        title: 'Azure Agony',
        collection: 'Episode 4'
    },
    { 
        name: 'e4m8',
        title: 'The Nameless City',
        collection: 'Episode 4'
    },
    { 
        name: 'end',
        title: 'Shub-Niggurath\'s Pit',
        collection: ''
    },
] as GameMap[]
